import { MtfComponent, MtfComponentInput } from '@/types/schema';

import { MtfElementsState } from '../types';
import { getMtfPairingsInput } from '.';

const EMPTY_ARRAY: never[] = [];

export const adaptMtfElements = (mtfComponent: MtfComponentInput | undefined | null) => {
  if (!mtfComponent) {
    return EMPTY_ARRAY;
  }

  const { leftElements, rightElements } = mtfComponent;

  const adaptedMtfElements: MtfElementsState[] = Array(leftElements.length)
    .fill(0)
    .map((_, index) => {
      return {
        leftElement: leftElements[index],
        rightElement: rightElements[index],
      };
    });

  return adaptedMtfElements;
};

export const adaptMtfComponentElements = (mtfComponent?: MtfComponent | null) => {
  if (!mtfComponent) {
    return EMPTY_ARRAY;
  }

  const { leftElements, rightElements } = mtfComponent;

  const adaptedMtfElements = Array(leftElements.length)
    .fill(0)
    .map((_, index) => {
      return {
        leftElement: leftElements[index],
        rightElement: rightElements[index],
      };
    });

  return adaptedMtfElements;
};

export const adaptMtfElementsToInput = (mtfElements: MtfElementsState[]) => {
  const adaptedMtfComponentInput = mtfElements.reduce(
    (acc, mtfElement) => {
      acc.leftElements.push(mtfElement.leftElement);
      acc.rightElements.push(mtfElement.rightElement);
      return acc;
    },
    {
      leftElements: [],
      rightElements: [],
      pairings: getMtfPairingsInput(mtfElements.length),
    } as MtfComponentInput,
  );

  return adaptedMtfComponentInput;
};
